import {hasPermission, isUserAuthenticated} from '../shared/authUtils';
import React from 'react';
import {Redirect, Route} from 'react-router-dom';

const PrivateRoute = ({component: Component, permissions, ...rest}) => (
    <Route
        {...rest}
        render={props => {
            if (!isUserAuthenticated()) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{pathname: '/account/login', state: {from: props.location}}}/>;
            }

            // check if route is restricted by role
            if (!hasPermission(permissions)) {
                return <Redirect to={{pathname: '/'}}/>;
            }

            // authorised so return component
            return <Component {...props} />;
        }}
    />
);

export default PrivateRoute;
